module.exports = "<app-add-registration></app-add-registration>\r\n"